/* assets/gc-reviews-page.js – "The Guest Book" reviews page.
   Progressive enhancement over the server HTML of sections/gc-reviews-page.liquid: shape tabs,
   search, filter popover, show all, quote "More", review drawer, photo lightbox, all-photos
   gallery and quick add to cart. Every review, photo and product fact is read from the DOM. */
(function () {
  'use strict';

  var root = document.querySelector('[data-gcrv]');
  if (!root || root.hasAttribute('data-ready')) return;
  root.setAttribute('data-ready', '');

  /* Overlays live at <body> level so fixed positioning is never trapped by a transformed parent. */
  var layer = root.querySelector('[data-gcrv-layer]');
  if (!layer) return;
  document.body.appendChild(layer);

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LIMIT = window.matchMedia && window.matchMedia('(max-width: 600px)').matches ? 4 : 8;
  var THEME_KW = {
    box: ['box', 'packag', 'presentation', 'unbox'],
    expensive: ['expensive', 'high end', 'high-end', 'fancy', 'luxur'],
    gift: ['gift'],
    kept: ['keep', 'kept', 'second set', 'another set', 'myself'],
    safe: ['arrived', 'packed', 'break', 'intact', 'condition'],
    compliments: ['compliment', 'guest', 'everyone', 'impress', 'wow']
  };
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6.5a3 3 0 016 0V8"/><path d="M12 11.5v5M9.5 14h5"/></svg>';
  var CHEV = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>'; };

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rxq(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var WRE = {};
  function wre(k) { return WRE[k] || (WRE[k] = new RegExp('(^|[^a-z0-9])' + rxq(k.toLowerCase()), 'i')); }
  /* highlight whole words: a token matches at a word start and the mark runs to the end of that word */
  function hl(text, kw) {
    var h = esc(text);
    var ks = (kw || []).filter(function (k) { return k.length > 1 && !/^(amp|quot|lt|gt|39|#39)$/.test(k); });
    if (!ks.length) return h;
    var re = new RegExp('(^|[^A-Za-z0-9&#])(' + ks.map(function (k) { return rxq(esc(k)); }).join('|') + ')([A-Za-z0-9’-]*)', 'gi');
    return h.replace(re, function (m, a, b, c) { return a + '<mark>' + b + c + '</mark>'; });
  }
  function sentences(t) {
    var out = [], re = /[.!?]\s+(?=[A-Z"“'‘(])/g, m, last = 0;
    while ((m = re.exec(t))) { out.push(t.slice(last, m.index + 1)); last = m.index + m[0].length; }
    out.push(t.slice(last));
    return out.filter(Boolean);
  }
  function excerpt(r, kw, max) {
    var se = r.se || (r.se = sentences(r.b)), st = 0, i, k, out = [];
    if (kw && kw.length) {
      for (i = 0; i < se.length; i++) {
        var l = se[i].toLowerCase();
        if (kw.some(function (x) { return wre(x).test(l); })) { st = i; break; }
      }
    }
    for (k = st; k < se.length; k++) {
      if (out.length && out.concat([se[k]]).join(' ').length > max) break;
      out.push(se[k]);
    }
    var t = out.join(' ');
    if (st > 0) t = '… ' + t;
    if (st + out.length < se.length) t = t + ' …';
    return t;
  }
  function stars(v, mod) {
    var w = Math.max(0, Math.min(100, v / 5 * 100));
    return '<span class="rv-stars' + (mod ? ' rv-stars--' + mod : '') + '" aria-hidden="true"><i style="width:' + w.toFixed(1) + '%"></i></span><span class="rv-sr">Rated ' + v + ' out of 5</span>';
  }
  function big(u) { return String(u || '').replace(/([?&]w=)\d+/, '$1920').replace(/\._SX\d+_\./, '._SX920_.'); }
  function shopRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function lock(on) { document.documentElement.classList.toggle('gcrv-lock', on); }

  /* ---------- read the server-rendered cabinet ---------- */
  var grid = $('#gcrv-grid', root);
  var CARDS = [], REV = {};
  $$('.rv-card-li', grid).forEach(function (li, idx) {
    var d = li.dataset, list = $('.rv-c-list', li), quotes = $('.rv-quotes', li);
    var c = {
      li: li, idx: idx, h: d.h || '', tab: d.shape || '', ty: d.ty || '', set: d.set || '', c: +d.c || 0, avg: d.avg || '',
      price: d.price || '', url: d.url || '#', vid: d.variantId || '', img: $('.rv-pk', li),
      title: (($('.rv-c-title', li) || {}).textContent || '').trim(), quotes: quotes, quotesHTML: quotes ? quotes.innerHTML : '',
      dist: ((list && list.getAttribute('data-dist')) || '0,0,0,0,0').split(',').map(Number), revs: []
    };
    $$('.rv-entry', li).forEach(function (a) {
      var t = $('h4', a), b = $('.rv-entry-b', a), by = $('.rv-by', a), dt = $('.rv-entry-d', a);
      var r = {
        el: a, ri: +a.dataset.ri, r: +a.dataset.r, th: (a.dataset.themes || '').split(' ').filter(Boolean), np: +a.dataset.np || 0,
        t: t ? t.textContent : '', b: b ? b.textContent : '', n: by ? by.textContent.trim() : '', d: dt ? dt.textContent : '', card: c
      };
      r.hay = (r.b + ' ' + r.t + ' ' + c.title + ' ' + c.ty).toLowerCase();
      c.revs.push(r);
      REV[r.ri] = r;
    });
    CARDS.push(c);
  });
  var sheet = $('[data-wall-list]', root);
  var WALL = sheet ? sheet.getAttribute('data-wall-list').split(',').map(function (p) { return p.split(':').map(Number); }) : [];

  /* ---------- state + filters ---------- */
  var S = { tab: 'all', q: '', five: false, ph: false, th: null, all: true };
  var tabs = $$('.rv-tab', root), chips = $$('.rv-chip', root);
  var resEl = $('[data-res]', root), moreRow = $('[data-more-row]', root), emptyEl = $('[data-empty]', root);
  var fcount = $('[data-fcount]', root), searchbox = $('[data-searchbox]', root), qIn = $('#gcrv-q', root);
  var fbtn = $('[data-fbtn]', root), fpanel = $('#gcrv-fpanel', root), t5 = $('[data-t5]', root), tph = $('[data-tph]', root);

  function toks() { return S.q.toLowerCase().split(/\s+/).filter(Boolean); }
  function active() { return !!(toks().length || S.five || S.ph || S.th); }
  function hk() { var t = toks(); return t.length ? t : (S.th ? THEME_KW[S.th] : []); }
  function match(r, tk) {
    if (S.five && r.r !== 5) return false;
    if (S.ph && !r.np) return false;
    if (S.th && r.th.indexOf(S.th) < 0) return false;
    for (var i = 0; i < tk.length; i++) { if (!wre(tk[i]).test(r.hay)) return false; }
    return true;
  }
  function quote(r, kw) {
    return '<figure class="rv-q"><p>“' + hl(excerpt(r, kw, 320), kw) + '”</p><button class="rv-qmore" type="button" data-more>More</button><figcaption>' + stars(r.r, 'sm') + '<span class="rv-nm">' + esc(r.n) + '</span></figcaption></figure>';
  }
  function clampCheck(scope) {
    $$('.rv-q', scope).forEach(function (f) {
      if (f.classList.contains('open')) return;
      var p = f.querySelector('p');
      f.classList.toggle('clamped', !!p && p.scrollHeight > p.clientHeight + 2);
    });
  }
  function label(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function render() {
    var tk = toks(), act = active(), kw = hk(), counts = { all: 0 }, shown = [], mtot = 0;
    CARDS.forEach(function (c) {
      c.m = act ? c.revs.filter(function (r) { return match(r, tk); }) : c.revs;
      if (act && !c.m.length) return;
      counts.all++;
      counts[c.tab] = (counts[c.tab] || 0) + 1;
      if (S.tab === 'all' || c.tab === S.tab) { shown.push(c); mtot += c.m.length; }
    });
    tabs.forEach(function (b) {
      var n = counts[b.dataset.tab] || 0, el = $('.rv-tab-n', b);
      if (el) el.textContent = n;
      b.classList.toggle('is-empty', n === 0);
    });
    shown.sort(act ? function (a, b) { return (b.m.length - a.m.length) || (a.idx - b.idx); } : function (a, b) { return a.idx - b.idx; });
    var cut = (!S.all && shown.length > LIMIT + 2) ? LIMIT : shown.length;
    var frag = document.createDocumentFragment(), on = {};
    shown.forEach(function (c, i) { on[c.idx] = 1; c.li.hidden = i >= cut; frag.appendChild(c.li); });
    CARDS.forEach(function (c) { if (!on[c.idx]) { c.li.hidden = true; frag.appendChild(c.li); } });
    grid.appendChild(frag);
    grid.classList.remove('is-limited');
    CARDS.forEach(function (c) {
      if (!c.quotes) return;
      if (act && on[c.idx] && c.m.length) {
        var mc = c.m.length;
        c.quotes.innerHTML = '<span class="rv-match">' + mc + ' matching ' + (mc === 1 ? 'review' : 'reviews') + '</span>' + quote(c.m[0], kw);
        c.qAct = true;
      } else if (c.qAct) {
        c.quotes.innerHTML = c.quotesHTML;
        c.qAct = false;
      }
    });
    if (moreRow) {
      moreRow.hidden = cut >= shown.length;
      $('[data-more-txt]', moreRow).textContent = 'Showing ' + cut + ' of ' + shown.length + ' sets';
      $('[data-showall]', moreRow).textContent = 'Show all ' + shown.length + ' sets';
    }
    if (emptyEl) emptyEl.hidden = shown.length > 0;
    if (resEl) {
      var tl = '';
      if (S.tab !== 'all') tabs.forEach(function (b) { if (b.dataset.tab === S.tab) tl = ' in ' + esc(label(b.querySelector('span:not(.rv-tab-n):not(.rv-tab-all)'))); });
      var desc = [];
      if (tk.length) desc.push('“' + esc(S.q.trim()) + '”');
      if (S.th) chips.forEach(function (c) { if (c.dataset.th === S.th) desc.push(esc(label(c))); });
      if (S.five) desc.push('5 stars');
      if (S.ph) desc.push('with photos');
      resEl.innerHTML = act ? ('<b>' + shown.length + ' set' + (shown.length === 1 ? '' : 's') + '</b>' + tl + ' · <b>' + mtot + '</b> matching review' + (mtot === 1 ? '' : 's') + ' for ' + desc.join(', ') + '<button type="button" data-clear>Clear</button>') : '';
    }
    var nf = (S.five ? 1 : 0) + (S.ph ? 1 : 0) + (S.th ? 1 : 0);
    if (fcount) { fcount.textContent = nf || ''; fcount.classList.toggle('on', nf > 0); }
    if (searchbox) searchbox.classList.toggle('has-q', !!S.q);
    clampCheck(grid);
  }
  function setTab(k) {
    S.tab = k;
    tabs.forEach(function (b) { var on = b.dataset.tab === k; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', String(on)); });
    render();
  }
  function setToggle(btn, on) { if (btn) { btn.classList.toggle('is-on', on); btn.setAttribute('aria-pressed', String(on)); } }
  function clearAll() {
    S.q = ''; S.five = false; S.ph = false; S.th = null;
    if (qIn) qIn.value = '';
    setToggle(t5, false); setToggle(tph, false);
    chips.forEach(function (c) { setToggle(c, false); });
    render();
  }
  function toTop() {
    var y = $('#cabinet', root).getBoundingClientRect().top + window.pageYOffset + 60;
    if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
  }

  /* ---------- review drawer ---------- */
  var side = $('#gcrv-side', layer), scrim = $('.rv-scrim', layer), lb = $('#gcrv-lb', layer), toast = $('[data-toast]', layer);
  var sideFocus = null, lbFocus = null;
  function qadd(c) {
    return '';
  }
  function distHTML(d) {
    var t = (d[0] + d[1] + d[2] + d[3] + d[4]) || 1;
    return '<div class="rv-dist" role="img" aria-label="Rating split in these reviews">' + d.map(function (n, i) {
      return '<span>' + (5 - i) + '</span><span class="rv-bar"><i style="width:' + (n / t * 100).toFixed(1) + '%"></i></span><span class="rv-num">' + Math.round(n / t * 100) + '%</span>';
    }).join('') + '</div>';
  }
  function thumb(c, w) {
    var src = c.img ? (c.img.currentSrc || c.img.getAttribute('src')) : '';
    return '<div class="rv-thumb">' + (src ? '<img src="' + esc(src) + '" alt="" width="' + w + '" height="' + w + '">' : '') + '</div>';
  }
  var CUR = null;
  function openSide(c, opts) {
    CUR = c;
    sideFocus = document.activeElement;
    var tk = toks(), act = active(), kw = hk(), ids = c.revs.slice(), hits = {};
    if (act) {
      var m = ids.filter(function (r) { return match(r, tk); });
      m.forEach(function (r) { hits[r.ri] = 1; });
      ids = m.concat(ids.filter(function (r) { return !hits[r.ri]; }));
    }
    var back = (opts && opts.back) ? '<a class="rv-side-back" href="' + esc(c.url) + '" data-back>&larr; Back to this set</a>' : '';
    side.innerHTML = '<div class="rv-side-h">' + thumb(c, 84) + '<div>' + back + '<p class="rv-ctype">' + esc(c.ty) + '</p><h3 id="gcrv-side-t">' + esc(c.title) + '</h3><div class="rv-meta">' + stars(+c.avg || 0, 'sm') + '<span>' + esc(c.avg) + '</span><span class="rv-muted">' + c.c + ' reviews' + (c.set ? ' · ' + esc(c.set) : '') + '</span></div></div><button class="rv-xbtn" type="button" data-close aria-label="Close">' + X + '</button></div>' +
      '<div class="rv-side-b"><div class="rv-side-sum"><span class="rv-bign">' + esc(c.avg) + '</span>' + distHTML(c.dist) + '</div><p class="rv-side-note">' + (act ? 'Matches for your filters first. ' : '') + 'Unedited, the grumpy ones too.</p><ul class="rv-revlist" role="list"></ul></div>' +
      '<div class="rv-side-f"><span class="rv-price">' + esc(c.price) + '</span><a class="rv-btn rv-btn--green" href="' + esc(c.url) + '">Shop the set</a>' + qadd(c) + '</div>';
    side.setAttribute('aria-labelledby', 'gcrv-side-t');
    var ul = $('.rv-revlist', side), frag = document.createDocumentFragment();
    ids.forEach(function (r) {
      var el = r.el.cloneNode(true), li = document.createElement('li');
      el.removeAttribute('id');
      var h = $('h4', el), b = $('.rv-entry-b', el);
      if (h && kw.length) h.innerHTML = hl(r.t, kw);
      if (hits[r.ri]) { el.classList.add('is-hit'); if (b) b.innerHTML = hl(r.b, kw); }
      li.appendChild(el);
      frag.appendChild(li);
    });
    ul.appendChild(frag);
    side.classList.add('on');
    scrim.classList.add('on');
    lock(true);
    $('.rv-side-b', side).scrollTop = 0;
    var x = $('[data-close]', side);
    if (x) x.focus();
    if (c.h && history.replaceState) history.replaceState(null, '', '#' + c.h);
  }
  function closeSide() {
    var deep = DEEP; DEEP = null; CUR = null;
    if (history.replaceState && location.hash) history.replaceState(null, '', location.pathname + location.search);
    if (deep) setTimeout(function () { alignCard(deep); }, 0);
    side.classList.remove('on');
    scrim.classList.remove('on');
    if (!lb.classList.contains('on')) lock(false);
    if (sideFocus && sideFocus.focus) sideFocus.focus();
  }

  /* ---------- lightbox: one review's photos, or the photo wall ---------- */
  var LB = { ri: 0, pi: 0, list: null, idx: 0 };
  function photosOf(r) { return $$('.rv-eph img', r.el).map(function (i) { return big(i.getAttribute('src')); }); }
  function openLb(ri, pi, list, idx) {
    var r = REV[ri];
    if (!r) return;
    if (!lb.classList.contains('on')) lbFocus = document.activeElement;
    LB = { ri: ri, pi: pi, list: list || null, idx: idx || 0 };
    var ph = photosOf(r), c = r.card, n = list ? list.length : ph.length, pos = list ? LB.idx : pi;
    lb.innerHTML = '<div class="rv-lb-wrap"><div class="rv-lb-p"><div class="rv-lb-img"><img src="' + esc(ph[pi] || '') + '" alt="Customer photo from ' + esc(r.n) + ' of ' + esc(c.title) + '">' +
      (n > 1 ? '<button class="rv-lb-nav rv-lb-nav--prev" type="button" data-lbstep="-1" aria-label="Previous photo">' + CHEV('M15 5l-7 7 7 7') + '</button><button class="rv-lb-nav rv-lb-nav--next" type="button" data-lbstep="1" aria-label="Next photo">' + CHEV('M9 5l7 7-7 7') + '</button><span class="rv-lb-count">' + (pos + 1) + ' / ' + n + '</span>' : '') + '</div>' +
      '<div class="rv-lb-t"><button class="rv-xbtn" type="button" data-lbclose aria-label="Close">' + X + '</button>' + stars(r.r) + (r.t ? '<h4>' + esc(r.t) + '</h4>' : '') + '<p class="rv-lb-body">' + esc(r.b) + '</p><div class="rv-by"><span class="rv-nm">' + esc(r.n) + '</span><span>' + esc(r.d) + '</span></div>' +
      '<div class="rv-lb-prod">' + thumb(c, 72) + '<div><b>' + esc(c.title) + '</b><span>' + esc(c.price) + ' · ' + esc(c.avg) + ' from ' + c.c + ' reviews</span></div><div class="rv-lb-act"><a class="rv-btn rv-btn--green" href="' + esc(c.url) + '">Shop the set</a>' + qadd(c) + '</div></div></div></div></div>';
    lb.classList.add('on');
    lock(true);
    var x = $('[data-lbclose]', lb);
    if (x) x.focus();
  }
  function lbStep(d) {
    if (LB.list) {
      var i = (LB.idx + d + LB.list.length) % LB.list.length;
      openLb(LB.list[i][0], LB.list[i][1], LB.list, i);
    } else {
      var n = photosOf(REV[LB.ri]).length;
      if (n > 1) openLb(LB.ri, (LB.pi + d + n) % n);
    }
  }
  function closeLb() {
    lb.classList.remove('on');
    if (!side.classList.contains('on')) lock(false);
    if (lbFocus && lbFocus.focus) lbFocus.focus();
  }

  /* ---------- quick add ---------- */
  var tt;
  function showToast(msg) {
    $('[data-toast-txt]', toast).textContent = msg;
    toast.classList.add('on');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('on'); }, 2600);
  }
  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    var text = btn.classList.contains('rv-c-atc') ? btn.textContent : null;
    btn.setAttribute('aria-busy', 'true');
    if (text) btn.textContent = 'Adding…';
    function done(ok) {
      btn.removeAttribute('aria-busy');
      if (!text) { if (ok) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); } return; }
      btn.textContent = ok ? 'Added' : text;
      if (ok) setTimeout(function () { btn.textContent = text; }, 1800);
    }
    var items = [{ id: id, quantity: 1 }];
    if (window.GCCart && typeof window.GCCart.add === 'function') {
      Promise.resolve(window.GCCart.add(items, { open: true })).then(function () { done(true); }, function () { done(false); });
      return;
    }
    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      showToast('Added to your cart');
      done(true);
    }).catch(function () {
      showToast('Could not add to cart. Please try again.');
      done(false);
    });
  }

  /* ---------- all-photos gallery ---------- */
  var gal = $('#gcrv-gal', layer), galV = $('[data-galv]', gal), galImg = $('[data-galimg]', gal);
  var galC = $('[data-galc]', gal), galR = $('[data-galr]', gal), tiles = $$('.rv-gal-tile', gal), cur = 0, galFocus = null, galReady = false;
  function openGal() {
    galFocus = document.activeElement;
    gal.hidden = false;
    lock(true);
    if (!galReady) {
      galReady = true;
      gal.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') e.target.classList.add('on'); }, true);
      tiles.forEach(function (t) { var i = t.querySelector('img'); if (i && i.complete && i.naturalWidth) i.classList.add('on'); });
    }
    setTimeout(function () { var x = $('[data-gx]', gal); if (x) x.focus(); }, 30);
  }
  function closeGal() {
    gal.hidden = true;
    galV.hidden = true;
    if (!side.classList.contains('on') && !lb.classList.contains('on')) lock(false);
    if (galFocus && galFocus.focus) galFocus.focus();
  }
  function gstars(n) { var o = ''; for (var i = 1; i <= 5; i++) o += i <= n ? '★' : '☆'; return '<span class="rv-gstars" aria-hidden="true">' + o + '</span>'; }
  function showG(i, focus) {
    if (!tiles.length) return;
    cur = (i + tiles.length) % tiles.length;
    var t = tiles[cur], im = t.querySelector('img'), art = document.getElementById('gcrv-g' + t.dataset.ri), h = art ? art.dataset.h : '';
    galV.hidden = false;
    galImg.removeAttribute('src');
    galImg.src = big(im.getAttribute('src'));
    galImg.alt = im.alt;
    galC.textContent = (cur + 1) + ' / ' + tiles.length;
    galR.innerHTML = (art ? gstars(+art.dataset.r) + art.innerHTML : '') + (h ? '<a class="rv-gbtn" href="' + esc(shopRoot() + 'products/' + h) + '">Shop the set</a>' : '');
    galV.scrollTop = 0;
    if (focus) { var b = $('[data-gb]', galV); if (b) b.focus(); }
  }
  gal.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gi],[data-gx],[data-gb],[data-gs]');
    if (!t) return;
    if (t.hasAttribute('data-gx')) closeGal();
    else if (t.hasAttribute('data-gb')) { galV.hidden = true; var tile = tiles[cur]; if (tile) tile.focus(); }
    else if (t.hasAttribute('data-gs')) showG(cur + (+t.dataset.gs));
    else { e.preventDefault(); showG(+t.dataset.gi, true); }
  });

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    if (fpanel && !e.target.closest('.rv-fwrap')) { fpanel.hidden = true; if (fbtn) fbtn.setAttribute('aria-expanded', 'false'); }
    var t = e.target.closest('[data-showall],[data-lb],[data-read],.rv-tab,.rv-chip,[data-clear],[data-close],[data-lbclose],[data-lbstep],[data-add],[data-more],[data-wall],[data-allph],[data-fbtn],[data-t5],[data-tph],[data-qx]');
    if (!t || !(root.contains(t) || layer.contains(t))) {
      if (e.target === lb || (e.target.classList && e.target.classList.contains('rv-lb-wrap'))) closeLb();
      return;
    }
    if (t.hasAttribute('data-add')) { e.preventDefault(); addToCart(t); return; }
    if (t.hasAttribute('data-wall')) { var w = +t.dataset.wall; if (WALL[w]) openLb(WALL[w][0], WALL[w][1], WALL, w); return; }
    if (t.hasAttribute('data-allph')) { e.preventDefault(); openGal(); return; }
    if (t.hasAttribute('data-fbtn')) { var open = fpanel.hidden; fpanel.hidden = !open; t.setAttribute('aria-expanded', String(open)); return; }
    if (t.hasAttribute('data-more')) { var f = t.closest('.rv-q'); f.classList.toggle('open'); t.textContent = f.classList.contains('open') ? 'Less' : 'More'; return; }
    if (t.hasAttribute('data-showall')) { S.all = true; render(); return; }
    if (t.hasAttribute('data-lb')) { openLb(+t.dataset.ri, +t.dataset.pi); return; }
    if (t.hasAttribute('data-read')) {
      var li = t.closest('.rv-card-li');
      for (var i = 0; i < CARDS.length; i++) { if (CARDS[i].li === li) { openSide(CARDS[i]); break; } }
      return;
    }
    if (t.classList.contains('rv-tab')) { setTab(t.dataset.tab); toTop(); return; }
    if (t.classList.contains('rv-chip')) {
      var k = t.dataset.th;
      S.th = S.th === k ? null : k;
      chips.forEach(function (c) { setToggle(c, c.dataset.th === S.th); });
      render(); toTop(); return;
    }
    if (t.hasAttribute('data-clear')) { clearAll(); return; }
    if (t.hasAttribute('data-close')) { closeSide(); return; }
    if (t.hasAttribute('data-lbclose')) { closeLb(); return; }
    if (t.hasAttribute('data-lbstep')) { lbStep(+t.dataset.lbstep); return; }
    if (t.hasAttribute('data-t5')) { S.five = !S.five; setToggle(t, S.five); render(); return; }
    if (t.hasAttribute('data-tph')) { S.ph = !S.ph; setToggle(t, S.ph); render(); return; }
    if (t.hasAttribute('data-qx')) { e.preventDefault(); S.q = ''; qIn.value = ''; render(); qIn.focus(); }
  });
  var qt;
  if (qIn) qIn.addEventListener('input', function () { clearTimeout(qt); qt = setTimeout(function () { S.q = qIn.value; render(); }, 120); });
  document.addEventListener('keydown', function (e) {
    if (document.querySelector('dialog[open]')) return; /* the cart drawer handles its own keys */
    var arrow = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (!gal.hidden) {
      if (e.key === 'Escape') { if (!galV.hidden) { galV.hidden = true; var tile = tiles[cur]; if (tile) tile.focus(); } else closeGal(); }
      else if (arrow && !galV.hidden) showG(cur + arrow);
      return;
    }
    if (lb.classList.contains('on')) {
      if (e.key === 'Escape') closeLb();
      else if (arrow) lbStep(arrow);
      return;
    }
    if (e.key === 'Escape') {
      if (side.classList.contains('on')) closeSide();
      else if (fpanel && !fpanel.hidden) { fpanel.hidden = true; fbtn.setAttribute('aria-expanded', 'false'); fbtn.focus(); }
    }
  });
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { clampCheck(root); }, 150); });

  /* ---------- charts grow when they scroll in (full size by default) ---------- */
  if (!RM && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        if (el.getBoundingClientRect().top < window.innerHeight * 0.25) return;
        el.classList.add('is-pre');
        void el.offsetWidth;
        requestAnimationFrame(function () { el.classList.remove('is-pre'); });
      });
    }, { threshold: 0.2 });
    $$('.rv-anim', root).forEach(function (el) { io.observe(el); });
  }

  /* ---------- deep links: /pages/reviews#<product-handle> (the PDP review-count link lands here) ---------- */
  var tbar = $('.rv-tb', root), targetTimer;
  function fromProduct(c) {
    var ref = document.referrer || '';
    return !!(ref && c && c.url && c.url !== '#' && ref.indexOf(location.origin + c.url.split('?')[0]) === 0);
  }
  var DEEP = null;
  function alignCard(c) {
    c.li.style.scrollMarginTop = ((tbar ? tbar.offsetHeight : 0) + 20) + 'px';
    c.li.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
  /* The browser keeps re-scrolling to the #fragment while lazy content loads, so wait until the card
     sits still under the toolbar (or 2.5 s) before opening the drawer over it. */
  function settle(c, done) {
    var tries = 0, lastY = null;
    (function tick() {
      var want = (tbar ? tbar.offsetHeight : 0) + 20, top = Math.round(c.li.getBoundingClientRect().top);
      if (Math.abs(top - want) <= 4 && lastY === window.scrollY) return done();
      lastY = window.scrollY;
      if (Math.abs(top - want) > 4) alignCard(c);
      if (++tries > 40) return done();
      setTimeout(tick, 60);
    })();
  }
  function revealCard(c, openDrawer) {
    if (c.li.hidden) { S.all = true; if (S.tab !== 'all' && c.tab !== S.tab) setTab('all'); else render(); }
    if (c.li.hidden) { clearAll(); S.all = true; render(); }
    alignCard(c);
    $$('.rv-card-li.is-target', grid).forEach(function (el) { el.classList.remove('is-target'); });
    c.li.classList.add('is-target');
    clearTimeout(targetTimer);
    targetTimer = setTimeout(function () { c.li.classList.remove('is-target'); }, 6000);
    if (openDrawer) settle(c, function () { DEEP = c; openSide(c, { back: fromProduct(c) }); });
  }
  function deepLink(openDrawer) {
    var h = decodeURIComponent((location.hash || '').slice(1));
    if (!h) return;
    for (var i = 0; i < CARDS.length; i++) { if (CARDS[i].h === h) { revealCard(CARDS[i], openDrawer); return; } }
    if (document.getElementById(h)) return; /* a page section such as #photos: the browser already scrolled */
    if (!/^[a-z0-9][a-z0-9-]*$/.test(h)) return;
    var cab = $('#cabinet', root);
    if (cab) cab.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    showToast('No guest book entries for that set yet. Here is the whole book.');
  }
  window.addEventListener('hashchange', function () { deepLink(true); });
  side.addEventListener('click', function (e) {
    var a = e.target.closest('[data-back]');
    if (!a || !fromProduct(CUR) || history.length < 2) return;
    e.preventDefault();
    history.back();
  });

  render();
  deepLink(true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { clampCheck(root); });
})();
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.gcrv a[href^="#"]');
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'start' });
  });
})();
